import type { RacePageDTO, StarterDataTransferObject } from '@mobi/api-types'
import dayjs from '@mobi/utils/date/extendedDayjs'
import { get } from '@core/Services/ApiService'

export const getRacePageDataFromApi = async (
  meetingId: string,
  meetingDate: Date | string,
  raceNumber: number
): Promise<RacePageDTO> => {
  const formattedDate = dayjs(meetingDate).format('YYYY-MM-DD')
  const url =
    `/api/meetings/${meetingId}/${formattedDate}/race/${raceNumber}?includeSrm`.toLowerCase()
  const response = await get<RacePageDTO>({ url })
  return response
}

export const getRaceStartersFromApi = ({ fixtureDate, fixtureId, raceNumber }: GetRaceParams) =>
  get<StarterDataTransferObject[]>({
    url: `/api/meetings/${fixtureId}/${fixtureDate}/race/${raceNumber}/starters`,
  })

export const getRacesPageDataFromApi = ({ fixtureDate, fixtureId, raceNumbers }: GetRacesParams) =>
  raceNumbers.length === 1
    ? getRacePageDataFromApi(fixtureId, fixtureDate, raceNumbers[0])
    : get<RacePageDTO>({
        url: `/api/meetings/${fixtureId}/${fixtureDate}/races/${raceNumbers.join(',')}`,
      })

// =====
// Types
// =====

type GetRaceParams = {
  fixtureId: string
  fixtureDate: string
  raceNumber: number
}

type GetRacesParams = Omit<GetRaceParams, 'raceNumber'> & { raceNumbers: number[] }
